import { render, staticRenderFns } from "./n35-three-doors.vue?vue&type=template&id=2029adf7&scoped=true"
import script from "./n35-three-doors.vue?vue&type=script&lang=js"
export * from "./n35-three-doors.vue?vue&type=script&lang=js"
import style0 from "./n35-three-doors.vue?vue&type=style&index=0&id=2029adf7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2029adf7",
  null
  
)

export default component.exports